export const removeUnderScore = (str) => {
    const rmucstr = str.replace(/_/g, " ");
    // using string.split to gey char array
    let arr = rmucstr.split(" ");
    const res = arr.map((a) => a.charAt(0).toUpperCase() + a.slice(1));
    return res.toString().replace(',',' ');
}